import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_ON_TIME_STARTS_ENDS_FOR_SURGEONS_QUERY_KEY } from "../types/CommonTypes";
import { GET_ON_TIME_STARTS_ENDS_FOR_SURGEONS_RESPONSE } from "../types/ResponseTypes";

async function getSurgeonOnTimeStartEnd(
  tenantId: string,
  hospitalId: string,
  queryString: string
): Promise<GET_ON_TIME_STARTS_ENDS_FOR_SURGEONS_RESPONSE> {
  const { data } = await fetcher({
    url: `analytics/on-time-starts-ends-for-surgeons?${queryString}`,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

function useGetSurgeonOnTimeStartEndQuery(
  tenantId: string,
  hospitalId: string,
  queryString: string = ""
) {
  return useQuery({
    queryKey: [
      GET_ON_TIME_STARTS_ENDS_FOR_SURGEONS_QUERY_KEY,
      queryString,
      hospitalId,
      tenantId,
    ],
    queryFn: () => getSurgeonOnTimeStartEnd(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
  });
}

export default useGetSurgeonOnTimeStartEndQuery;
